<template>
    <footer>       
           <div class="text-center">     
                <div class="copyright">
                    {{currentVersion}}
                    <div class="mt-2">
                        <b-img class="logo" fluid src="/img/sefos.png" alt></b-img>
                    </div>
                </div>
            </div>
    </footer>
</template>
<script>
export default {
    data() {
        return {
            server_version: "",
            commit_hash: process.env.VUE_APP_COMMIT_HASH,
            package_version: process.env.VUE_APP_PACKAGE_VERSION
        }
    },
    methods: {
        async getServerVersion() {
            if(this.$route.meta.showVersion)
            {
                let self = this;
                this.$http.get(this.user.hostname + "/version")
                .then(function(result) {
                    self.server_version = result.data; 
                });
            }
        }
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
        showHeader(){
            return this.$route.meta.showHeader;
        },
        current_year() {
            return new Date().getFullYear();
        },
        currentVersion(){
            return "v." + this.commit_hash + "-" + this.package_version + "-" + this.server_version;
        }
    },
    mounted() {
        this.getServerVersion();
    }
}
</script>
